//----------------------------------------------------------------------------------------------------------------------
// Simple Gallery
// just wrap slides with class `.js-king-gallery`
// and add class `.js-king-gallery--slide` to each slide + define following attributes:
// - data-gallery-thumb="..." - <required> - thumbnail image url
// - data-gallery-src="..." - <required> - full size image url
// - data-gallery-sub-html="..." - <optional> - slide HTML description
//
// LightGallery can be also force bind by using `onload="LightGallery.bind(this);"`
// or force opened on click by using `onclick="return LightGallery.open(this);"`
// on `.js-king-gallery--slide` element.

export const KingGallery = {

	init: function() {
		let self = this;

		self.getSlidesSelector().forEach(function(slide) {
			self.bind(slide);
		});
	},

	bind: function(element) {
		let self = this;

		element.removeEventListener('click', self.getClickHandler(), false);
		element.addEventListener('click', self.getClickHandler());
	},

	open: function(event) {
		let self = this;

		self.initGallery(event);
		return false;
	},

	getClickHandler: function() {
		let self = this;

		return function (e) {
			e.preventDefault();
			self.initGallery(e.target);
		};
	},

	getSlidesSelector: function() {
		return Array.prototype.slice.call(document.querySelectorAll('.js-king-gallery--slide'));
	},

	initGallery: function(eventTarget) {
		let self = this;

		let slide = eventTarget.closest('.js-king-gallery--slide') || eventTarget.querySelector('.js-king-gallery--slide');
		let gallery = self.findGallery(eventTarget);
		let slides = Array.prototype.slice.call(gallery.querySelectorAll('.js-king-gallery--slide'));

		lightGallery(slide, {
			thumbnails: true,
			dynamic: true,
			dynamicEl: self.getSlidesData(slides),
			index: slides.indexOf(slide),
		});
	},

	findGallery: function(slider) {
		return slider.closest('.js-king-gallery');
	},

	getSlidesData: function(slides) {
		let self = this;

		return slides.map(function callback(slide) {
			return self.getSlideData(slide);
		});
	},

	getSlideData: function(slide) {
		return {
			downloadUrl: false,
			poster: '',
			src: slide.dataset.gallerySrc ? slide.dataset.gallerySrc : '',
			thumb: slide.dataset.galleryThumb ? slide.dataset.galleryThumb : '',
			subHtml: slide.dataset.gallerySubHtml ? slide.dataset.gallerySubHtml : '',
		};
	}
};

window.LightGallery = KingGallery;
KingGallery.init();
